var _title;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRequests = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Grupo 24201")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24201",
    "data-name": "Grupo 24201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1670",
    "data-name": "Ret\\xE2ngulo 1670",
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-git-pull-request",
    "data-name": "Icon feather-git-pull-request"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28440",
    "data-name": "Caminho 28440",
    style: {
      fill: "none",
      stroke: "#868686",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M23,19.31a3.69,3.69,0,1,1-3.69-3.69A3.69,3.69,0,0,1,23,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28441",
    "data-name": "Caminho 28441",
    style: {
      fill: "none",
      stroke: "#868686",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M8.39,4.69A3.7,3.7,0,1,1,4.69,1a3.7,3.7,0,0,1,3.7,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28442",
    "data-name": "Caminho 28442",
    style: {
      fill: "none",
      stroke: "#868686",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M12.34,4.64h4.54A2.46,2.46,0,0,1,19.34,7.1h0v8.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28443",
    "data-name": "Caminho 28443",
    style: {
      fill: "none",
      stroke: "#868686",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M4.69,8.23V23"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRequests, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/requests.bf57acab.svg";
export { ForwardRef as ReactComponent };